import React from 'react';
import { SubmoduleLayoutStyledComponent } from './submodule-layout.style';

export const SubmoduleLayoutComponent: React.FC<React.PropsWithChildren> = ({ children }) => (
    <SubmoduleLayoutStyledComponent>{children}</SubmoduleLayoutStyledComponent>
);
